/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Flex, Icon } from '@tonic-one/react';
import { AngleLeftIcon, AngleRightIcon } from '@tonic-one/react-icons';
import cloneDeep from 'lodash/cloneDeep';

import React from 'react';

import { useCasTreeTransferContext } from './context';
import { reorganizeTree, searchAllKey, traverseTreeData } from './utils';

const TransferButton: React.FC = () => {
  const {
    defaultValue,
    sonParMap,
    flatArray,
    readOnlyAllKeyLeft,
    readOnlyTreeDataSource,
    checkListLeft,
    handleCheckListLeftChange,
    dataSourceLeft,
    handleDataSourceLeftChange,
    checkListRight,
    handleCheckListRightChange,
    dataSourceRight,
    handleDataSourceRightChange,
    readOnlyAllKeyRight,
    handleReadOnlyAllKeyRightChange,
    readOnlyDataSourceRight,
    handleReadOnlyDataSourceRightChange,
    finallyValue,
    handleFinallyValueChange,
    handleIndeterminateLeftChange,
    isBrightLeft,
    handleIsBrightLeftChange,
    isBrightRight,
    handleIsBrightRightChange,
    disabled,
  } = useCasTreeTransferContext();
  const [handleToRight, handleToLeft] = React.useMemo(() => {
    const handleToRight = () => {
      if (checkListLeft.length === 0 && isBrightRight === false) {
        return;
      }
      // 取消左侧半选
      handleIndeterminateLeftChange(false);
      if (checkListLeft.length === readOnlyAllKeyLeft.length) {
        // 左侧全选
        // 保存右侧数据源
        handleDataSourceRightChange(cloneDeep(readOnlyTreeDataSource));
        // 保存右侧全部key
        handleReadOnlyAllKeyRightChange([...checkListLeft]);
        // 保存右侧只读数据供搜索用
        handleReadOnlyDataSourceRightChange(cloneDeep(readOnlyTreeDataSource));
        // 保存最终选择数据
        handleFinallyValueChange([...checkListLeft]);
        // 设置左侧数据禁用
        const treeData = cloneDeep(readOnlyTreeDataSource.treeData);
        traverseTreeData({
          treeData,
          callback: (item, index, parentId) => {
            if (checkListLeft.includes(item.key)) {
              item['disabled'] = true;
            }
          },
        });
        handleDataSourceLeftChange({ treeData });
      } else {
        // 部分选择
        // 获取所有选择的key以及其parent key
        let allKeys = searchAllKey(checkListLeft, sonParMap);
        allKeys = Array.from(new Set(allKeys.concat(finallyValue)));
        // 在flatten tree里找到所有对应的节点
        const allNodes = flatArray.filter((item) => allKeys.includes(item.key));
        // 重建右侧数据源
        const newRightTree = reorganizeTree(allNodes);
        // 保存右侧数据源
        handleDataSourceRightChange({ treeData: newRightTree });
        // 保存右侧只读全部key
        handleReadOnlyAllKeyRightChange([...allKeys]);
        // 保存右侧只读数据源供搜索
        handleReadOnlyDataSourceRightChange({
          treeData: cloneDeep(newRightTree),
        });
        // 保存最终选择数据
        handleFinallyValueChange([...checkListLeft]);
        // 禁用左侧已选项
        const treeData = cloneDeep(readOnlyTreeDataSource.treeData);
        traverseTreeData({
          treeData,
          callback: (item, index, parentId) => {
            if (checkListLeft.includes(item.key)) {
              item['disabled'] = true;
            }
          },
        });
        console.log('after');
        console.info(treeData);
        handleDataSourceLeftChange({ treeData });
      }
      // 取消按钮高亮
      handleIsBrightRightChange(false);
    };
    const handleToLeft = () => {
      // 没有选中
      if (checkListRight.length === 0 && !isBrightLeft) {
        return;
      }
      if (checkListRight.length === readOnlyAllKeyRight.length) {
        // 右侧全选，相当于全部清空
        handleDataSourceRightChange({ treeData: [] });
        handleReadOnlyDataSourceRightChange({ treeData: [] });
        handleReadOnlyAllKeyRightChange([]);
        handleCheckListRightChange([]);
        // 设置最终值
        handleFinallyValueChange([]);
        // 左侧选中也清空
        handleCheckListLeftChange([]);
        // 用只读数据源恢复左侧数据源
        handleDataSourceLeftChange(cloneDeep(readOnlyTreeDataSource));
      } else {
        // 右侧不全部选中
        // 右侧中剩下的key
        const restRightlKeys = readOnlyAllKeyRight.filter(
          (key) => !checkListRight.includes(key)
        );
        // 在flatTree中找到剩下的node
        const restNodes = flatArray.filter((item) =>
          restRightlKeys.includes(item.key)
        );
        // 重组右侧tree
        const newRightTree = reorganizeTree(restNodes);
        // 设置右侧数据源
        handleDataSourceRightChange({ treeData: newRightTree });
        // 设置右侧只读数据源供搜索
        handleReadOnlyDataSourceRightChange({
          treeData: cloneDeep(newRightTree),
        });
        // 右侧剩下的key就是只读所有key
        handleReadOnlyAllKeyRightChange([...restRightlKeys]);
        // 设置左侧key
        const newCheckListLeft = checkListLeft.filter(
          (key) => !checkListRight.includes(key)
        );
        handleCheckListLeftChange(newCheckListLeft);
        // 设置左侧数据禁用
        const treeData = cloneDeep(readOnlyTreeDataSource.treeData);
        traverseTreeData({
          treeData,
          callback: (item, index, parentId) => {
            if (newCheckListLeft.includes(item.key)) {
              item['disabled'] = true;
            } else {
              item['disabled'] = false;
            }
          },
        });
        // 设置左侧数据源
        handleDataSourceLeftChange({ treeData });
      }
      // 取消按钮高亮
      handleIsBrightLeftChange(false);
    };
    return [handleToRight, handleToLeft];
  }, [
    checkListLeft,
    readOnlyAllKeyLeft,
    readOnlyTreeDataSource,
    sonParMap,
    finallyValue,
    flatArray,
    dataSourceLeft,
    checkListRight,
    readOnlyAllKeyRight,
    isBrightLeft,
    isBrightRight,
  ]);
  React.useEffect(() => {
    if (defaultValue.length) {
      handleToRight();
    }
  }, [defaultValue]);
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      ml="12px"
      mr="12px"
      width="24px"
    >
      <Button
        variant="secondary"
        onClick={() => handleToRight()}
        mb="8px"
        width="24px"
        size="sm"
        disabled={disabled}
      >
        <Icon
          as={AngleRightIcon}
          color={isBrightRight ? 'blue:50' : 'white:primary'}
        />
      </Button>
      <Button
        width="24px"
        size="sm"
        variant="secondary"
        onClick={() => handleToLeft()}
        disabled={disabled}
      >
        <Icon
          as={AngleLeftIcon}
          color={isBrightLeft ? 'blue:50' : 'white:primary'}
        />
      </Button>
    </Flex>
  );
};

export default React.memo(TransferButton);
